import { awards } from './awards'
import { awardWinningVehicles } from './awardWinningVehicles'
import { awardWinningVehicleDetail } from './awardWinningVehicleDetail'
import { popularVehicles } from './popularVehicles'
import { estimateVehicleValue } from './estimateVehicleValue'

export const researchApi = {
  awards,
  awardWinningVehicles,
  awardWinningVehicleDetail,
  popularVehicles,
  estimateVehicleValue,
}
